/* eslint-disable react/destructuring-assignment */
import { Flex, FlexProps, useBreakpointValue } from "@chakra-ui/react";

import { OFText } from "design_system/components/OFText";
import { ThumbUpIcon } from "design_system/icons";
import { colors } from "src/colors";

const SIZES = {
  large: { h: "36px", p: "18px 8px" },
  small: { h: "24px", p: "14px 4px" }
};

type Props = FlexProps & {
  size?: "large" | "small";
  iconProps?: { [value: string]: string };
};

export const MostPopularBadge = ({ size = "small", iconProps, children, ...props }: Props) => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      bg={colors.orange[400]}
      w="max-content"
      borderRadius="20px"
      {...SIZES[size]}
      {...props}
    >
      <ThumbUpIcon color={colors.white.off} size={size === "large" ? 24 : 20} {...iconProps} />
      {!isMobile && (
        <OFText
          flex={1}
          color={colors.white.off}
          textStyle={size === "large" ? "subhead1" : "labels"}
          pr="10px"
        >
          {children}
        </OFText>
      )}
    </Flex>
  );
};
